// src/store/index.js

import Vue from 'vue'
import Vuex from 'vuex'
import device from './modules/device' // 设备检测模块

Vue.use(Vuex)

// 自动加载 modules 目录下的所有模块
const modulesFiles = require.context('./modules', false, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  modules: {
    device,
    ...modules // 其他自动加载的模块
  },
  strict: process.env.NODE_ENV !== 'production' // 开发环境开启严格模式
})